export * from './scenarios';
export * from './verifyEmailCode';

import { ProfileType } from '../types';

export * from './errors';

export const getProfileType = (type: string): ProfileType => {
  switch (type) {
    case 'MAIN_USER':
      return ProfileType.MAIN_USER;
    case 'BENEFICIARY':
      return ProfileType.BENEFICIARY;
    case 'ASSISTANT':
      return ProfileType.ASSISTANT;
    default:
      throw new Error('Invalid encryption type');
  }
};
